import { render, staticRenderFns } from "./mobile_legal_notices.vue?vue&type=template&id=31ba6b00&scoped=true&"
import script from "./mobile_legal_notices.vue?vue&type=script&lang=js&"
export * from "./mobile_legal_notices.vue?vue&type=script&lang=js&"
import style0 from "./mobile_legal_notices.vue?vue&type=style&index=0&id=31ba6b00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba6b00",
  null
  
)

export default component.exports